/** 
 * 临停缴费 无牌车请求入场 开通无感支付（添加车辆）
 *  */ 

export const NONELICENSEPLATEQUERY = "NONELICENSEPLATEQUERY"  // 生成临时车牌
export const NONELICENSEPLATEAPPROACH = "NONELICENSEPLATEAPPROACH"  // 无牌车入场请求

// 临停
export const TRMPORARYCHARGEPAYQUERY = "TRMPORARYCHARGEPAYQUERY"  // 可缴费车辆列表
export const TRMPORARYCHARGEADD = "TRMPORARYCHARGEADD"      // 提交临停缴费订单
export const TRMPORARYCHARGEQUERY = "TRMPORARYCHARGEQUERY"      // 车辆临停缴费详情
export const ORDERMERBERCOUPONSQUERY = "ORDERMERBERCOUPONSQUERY"      // 订单优惠券列表





// WEBPACK FOOTER //
// ./src/store/temporary/types.js